// extracted by mini-css-extract-plugin
export var details = "_gf-0";
export var inspectorPopover = "_gf-1";